import { render, staticRenderFns } from "./MensagemTodosUsuarios.vue?vue&type=template&id=591009f4"
import script from "./MensagemTodosUsuarios.vue?vue&type=script&lang=ts"
export * from "./MensagemTodosUsuarios.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports